import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, DISCLAIMER } from "../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1A1512] text-[#A79E93]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Link to="/" aria-label="Trafalgar International Inc — Home" className="inline-block" data-testid="footer-logo-link">
              <Logo variant="dark" size={36} dataTestId="footer-logo" />
            </Link>
            <p className="mt-6 text-sm leading-relaxed max-w-md">
              {DISCLAIMER.rebrandNotice}
            </p>
            <div className="mt-6 inline-flex items-center gap-3 text-white font-mono text-xs tracking-[0.22em] uppercase">
              <span className="h-1.5 w-1.5 rounded-full bg-[#F26A1B]" />
              OTCQB: {COMPANY.ticker} · CIK {COMPANY.cik}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white text-sm font-semibold tracking-wide mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white">About</Link></li>
              <li><Link to="/investors" data-testid="footer-link-investors" className="hover:text-white">Investors</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white text-sm font-semibold tracking-wide mb-4">Disclosures</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/sec-filings" data-testid="footer-link-sec" className="hover:text-white">SEC Filings</Link></li>
              <li>
                <a
                  href="https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0001695473&type=&dateb=&owner=include&count=40"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-edgar"
                  className="hover:text-white inline-flex items-center gap-1"
                >
                  SEC EDGAR <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.otcmarkets.com/stock/GCAN/quote"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-otcqb"
                  className="hover:text-white inline-flex items-center gap-1"
                >
                  OTCQB Quote <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
              <li><Link to="/legacy-assets" data-testid="footer-link-legacy" className="hover:text-white">Legacy Assets</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white text-sm font-semibold tracking-wide mb-4">Investor Contact</h4>
            <p className="text-sm mb-2">Investor Relations</p>
            <a
              href={`mailto:${COMPANY.irEmail}`}
              className="text-sm text-white hover:text-[#F26A1B] transition-colors"
              data-testid="footer-ir-email"
            >
              {COMPANY.irEmail}
            </a>
            <div className="mt-5 pt-5 border-t border-[#3A2E22]">
              <p className="eyebrow text-[#8A8075] mb-2">Corporate Address</p>
              <address
                className="not-italic text-sm text-white leading-relaxed"
                data-testid="footer-corporate-address"
              >
                {COMPANY.address.line1}
                {COMPANY.address.line2 && (
                  <>
                    <br />
                    {COMPANY.address.line2}
                  </>
                )}
                <br />
                {COMPANY.address.city}, {COMPANY.address.state} {COMPANY.address.postalCode}
              </address>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#3A2E22]">
          <p className="text-[12px] leading-relaxed text-[#8A8075] max-w-4xl" data-testid="footer-forward-looking">
            {DISCLAIMER.forwardLooking} {DISCLAIMER.edgarNote}
          </p>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs font-mono uppercase tracking-[0.2em] text-[#8A8075]">
            <span>© {year} Trafalgar International, Inc. All rights reserved.</span>
            <span>Formerly Greater Cannabis Company, Inc. · Rebrand {COMPANY.rebrandDate}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
